module.exports = __webpack_public_path__ + "84f1bd49030e046b47d51c7dc34611df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-28.png
// module id = 3119
// module chunks = 0